module.exports = __webpack_public_path__ + "static/media/15. Speaker Recai Biberoglu.8b8c2d69.png";